<template>
    <div>
        <loading-component :value="loading"/>
        <v-btn color="primary" @click="getData">
            Refresh
        </v-btn>
        <v-select :items="['963954044416', '963954044407']" v-model="number"></v-select>
        <v-layout justify-center>
            <img v-if="qr_code" :src="qr_code" alt="qrCode"/>
            <v-flex xs12 v-else class="title error">
                No Qr Code
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    import LoadingComponent from "@/components/LoadingComponent";

    export default {
        name: "GetQrCode",
        components: {LoadingComponent},
        data() {
            return {
                loading: false,
                qrCode: null,
                qr_code: null,
                number: '963954044416'
            }
        },
        title: 'QR Scan',
        watch: {
            number() {
                this.getData();
            }
        },
        mounted() {
            this.getData();
        },
        methods: {
            getData() {
                this.loading = true;
                this.axios.post(this.api.ACTIONS.QR_CODE, {number: this.number})
                    .then(
                        ({data}) => {
                            this.qr_code = data.data.qr_code;
                        }
                    ).catch(
                    ({data: {message}}) => console.log(message))
                    .finally(
                        () =>
                            this.loading = false
                    )
            }
        }
    }
</script>

<style scoped>

</style>